/**
 * Time-of-day greeting (SPEC Q5).
 *
 * Banding (matches the prototype's wording — see
 * the v2 prototype and the SCREEN-SPECS):
 *   - 05:00 – 11:59  → "Good morning"
 *   - 12:00 – 17:59  → "Good afternoon"
 *   - 18:00 – 04:59  → "Good evening"
 *
 * Uses the supplied `Date` so tests can pin the hour without mocking the
 * global clock; production callers pass `new Date()`.
 */
export function getTimeOfDayGreeting(now: Date = new Date()): string {
  const hour = now.getHours();
  if (hour >= 5 && hour < 12) return 'Good morning';
  if (hour >= 12 && hour < 18) return 'Good afternoon';
  return 'Good evening';
}
